// @ts-nocheck
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, Box, Divider, Typography } from '@material-ui/core';
import { StringUtils } from '../utils';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  title: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  content: {
    height: '100%',
    marginTop: theme.spacing(2),
  },
}));

function Section(props) {
  const classes = useStyles();

  const { id, title, className, children } = props;

  return (
    <Box id={StringUtils.makeId(id, 'section')} className={clsx(classes.container, className)}>
      <Typography id={StringUtils.makeId(id, 'title')} variant="h6" className={classes.title}>
        {title}
      </Typography>
      <Divider />
      <Box id={StringUtils.makeId(id, 'content')} className={classes.content}>
        {children}
      </Box>
    </Box>
  );
}

Section.defaultProps = {
  id: undefined,
  className: undefined,
};

Section.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Section;
